import { withInstall } from '@bigin/utils'
import TreeV2 from './src/tree.vue'

export const BTreeV2 = withInstall(TreeV2)
export default BTreeV2
